module.exports = __webpack_public_path__ + "static/media/yellowWarning.9950d13f.svg";